import { mergeClasses } from "@trex-2b/libs/tw-merge";

import { getAvatarInitials } from "./get-avatar-initials";

export type UserAvatarProps = {
  nickname: unknown;
  alt?: string;
  size?: number;
  className?: string;
};

export function UserAvatar({
  nickname,
  alt = "User avatar",
  size = 36,
  className,
}: UserAvatarProps) {
  const initials = getAvatarInitials(nickname);
  const fontSize = Math.max(12, Math.round(size * 0.4));

  return (
    <span
      role="img"
      aria-label={alt}
      className={mergeClasses(
        // Figma node `32946:3332` uses token `colors/紫3` => #8589c0.
        "inline-flex size-full select-none items-center justify-center rounded-full border-[1.25px] border-[#6B6E97] bg-[#8589C0] text-white",
        className,
      )}
      style={{ width: size, height: size }}
    >
      <span
        aria-hidden
        className="font-inter leading-none font-semibold tracking-[-0.15px]"
        style={{ fontSize }}
      >
        {initials}
      </span>
    </span>
  );
}
